import { ref, computed, type ComputedRef } from 'vue'
import { useRoute } from 'vue-router'

export type Idioma = 'pt' | 'en' | 'es'

export const IDIOMAS: { codigo: Idioma; nome: string; lang: string }[] = [
  { codigo: 'pt', nome: 'Português', lang: 'pt-BR' },
  { codigo: 'en', nome: 'English', lang: 'en' },
  { codigo: 'es', nome: 'Español', lang: 'es' },
]

// Páginas no visual novo: só elas têm tema, seletor de idioma e tradução.
// As demais seguem em português mesmo com outro idioma escolhido.
export const ROTAS_VISUAL_NOVO = ['/', '/implementacao-personalizada', '/a2', '/whitelabel']

const CHAVE = 'idioma-site'

function lerInicial(): Idioma {
  try {
    const salvo = localStorage.getItem(CHAVE)
    if (salvo === 'pt' || salvo === 'en' || salvo === 'es') return salvo
  } catch {
    // Sem armazenamento (aba privada): fica o português
  }
  return 'pt'
}

const escolhido = ref<Idioma>(lerInicial())

export function definirIdioma(idioma: Idioma): void {
  escolhido.value = idioma
  try {
    localStorage.setItem(CHAVE, idioma)
  } catch {
    // Vale só para esta visita
  }
}

export function useIdioma() {
  const route = useRoute()
  const idioma = computed<Idioma>(() => (ROTAS_VISUAL_NOVO.includes(route.path) ? escolhido.value : 'pt'))
  return { idioma, escolhido, definirIdioma }
}

// Cada componente declara { pt, en, es } com as mesmas chaves e usa o bloco do idioma ativo.
export function useTextos<T>(textos: Record<Idioma, T>): ComputedRef<T> {
  const { idioma } = useIdioma()
  return computed(() => textos[idioma.value])
}
